(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 2691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(18460);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12535:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-brake-repair-header.e9c70732.jpeg","height":650,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQMREgITUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8Amm3NtyyLN3IWeAAFf//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 57581:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-brake-repair-header.e9c70732.jpg","height":650,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQMREgITUf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8Amm3NtyyLN3IWeAAFf//Z","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 5120:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-logo-no-text.7abecb29.svg","height":47,"width":94});

/***/ }),

/***/ 8617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ AboutPageTitleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_img_nubrakes_brake_repair_header_jpeg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12535);
/* harmony import */ var _BgImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63549);




var AboutPageTitleSection = function(param) {
    var title = param.title, description = param.description, bgImageOverride = param.bgImageOverride;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BgImage__WEBPACK_IMPORTED_MODULE_3__/* .BgImage */ .D, {
            src: _public_img_nubrakes_brake_repair_header_jpeg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z || bgImageOverride,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "title text-white",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "description",
                        children: description
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 63549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BgImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_img_nubrakes_brake_repair_header_jpg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57581);



var BgImage = function(param) {
    var src = param.src, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center align-center relative h-[45vh] sm:h-[60vh]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src !== null && src !== void 0 ? src : _public_img_nubrakes_brake_repair_header_jpg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                alt: "NuBrakes Background Image",
                layout: "fill",
                objectFit: "cover",
                objectPosition: "top left"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    zIndex: 1
                },
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ YelpButton; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "Op": function() { return /* binding */ ViewAllCitiesButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export LearnMoreButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center bg-lime hover:bg-green-600 text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};
var LearnMoreButton = function(param) {
    var children = param.children;
    var baseClassName = "ml-1 inline-block justify-center bg-blue-900 text-white text-sm px-2 rounded";
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(baseClassName),
        children: children
    });
};
var ButtonOutline = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "opacity-50 cursor-not-allowed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: "".concat(className, " border-primary hover:text-white border inline-block justify-center bg-transparent hover:bg-primary text-primary py-2 text-lg font-semibold px-5 rounded ").concat(disabled ? disabledClassName : "")
    }, rest), {
        children: children
    }));
};
var YelpButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block w-full md:w-auto  border-gray-800 border justify-center bg-transparent hover:bg-gray-800 hover:text-white text-gray-800 py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};
var ViewAllCitiesButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block border-allCitiesGray border justify-center bg-transparent hover:bg-allCitiesGray hover:text-white text-allCitiesGray py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};


/***/ }),

/***/ 18737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ GraySection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var GraySection = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var baseClassName = "bg-gray-100";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, className)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 17743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ LandingPageButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68663);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73401);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);








function LandingPageButton(props) {
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_4__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: "/get-quote/",
            query: query
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(props.className),
                style: {
                    paddingTop: 8,
                    paddingBottom: 8,
                    paddingLeft: 25,
                    paddingRight: 25
                }
            }, props.buttonProps), {
                children: props.buttonText
            }))
        })
    });
}


/***/ }),

/***/ 18460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/LandingPageButton.tsx
var LandingPageButton = __webpack_require__(17743);
;// CONCATENATED MODULE: ./src/components/PricingPage/PricingInfo.tsx





var PricingInfo = function(param) {
    var image = param.image, buttonText = param.buttonText, title = param.title, orangeTitle = param.orangeTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid md:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-auto text-center md:text-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "title",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "orange-title",
                                children: orangeTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "description",
                                children: [
                                    "Pricing varies by vehicle make and model. For accurate pricing, contact our brake experts at",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:8558005629",
                                        children: "(855) 800-5629"
                                    }),
                                    " to get the correct pricing for your vehicle."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row justify-center md:justify-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                                    buttonText: buttonText
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "responsive",
                            src: image,
                            alt: "Brake Rotor",
                            className: "mx-auto"
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var GraySection = __webpack_require__(18737);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./public/img/nubrakes-logo-no-text.svg
var nubrakes_logo_no_text = __webpack_require__(5120);
;// CONCATENATED MODULE: ./src/components/PricingPage/PricingScheduleService.tsx









var PricingScheduleService = function(param) {
    var title = param.title;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySection/* GraySection */.g, {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pb-4 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: nubrakes_logo_no_text/* default */.Z,
                                alt: "NuBrakes Logo",
                                className: "mx-auto"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "description",
                            children: [
                                "Service currently available in",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/austin-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Austin, TX"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/houston-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Houston, TX"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/san-antonio-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "San Antonio, TX"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/dallas-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Dallas, TX"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/atlanta-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Atlanta, GA"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/nashville-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Nashville, TN"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/tampa-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Tampa, FL"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/orlando-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Orlando, FL"
                                }),
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/jacksonville-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Jacksonville, FL"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/miami-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Miami, FL"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    as: {
                                        pathname: "/cities/chicago-brake-repair/",
                                        query: query
                                    },
                                    href: "/cities/[slug]",
                                    children: "Chicago, IL"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pt-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageButton/* LandingPageButton */.K, {
                        buttonText: "Schedule My Brake Repair"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/AboutPageTitleSection.tsx
var AboutPageTitleSection = __webpack_require__(8617);
// EXTERNAL MODULE: ./public/img/nubrakes-brake-repair-header.jpg
var nubrakes_brake_repair_header = __webpack_require__(57581);
;// CONCATENATED MODULE: ./public/img/brake-rotor-colored.png
/* harmony default export */ var brake_rotor_colored = ({"src":"/_next/static/media/brake-rotor-colored.5b14b3b5.png","height":800,"width":800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAATlBMVEX////FPz9pZWjk5Ob5+fn78/OFgoa2tLfBwMNbWFyfoqjZ2NqXlZry5+j25uaXXGDalpa2dXZEREV2cnc3NjnUtLjRf3+1Tk7eaGfw0tIU0qyqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPklEQVR4nBXGSRLAIAgAwUFRwOx78v+PpuxTA+Wb6Ob7vVyBTdYaDkUkpTiU8iyn1VDwlvYwQK3VMfdk8wF+RXgBxy5XhgMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/pages/pricing.tsx









var PricingPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Brake Repair Pricing - NuBrakes Mobile Brake Repair",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "Need new brake pads, rotors or calipers? Let our brake experts provide you with a free, no-obligation brake repair quote!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutPageTitleSection/* AboutPageTitleSection */.P, {
                title: "Brake Repair Service Pricing",
                bgImageOverride: nubrakes_brake_repair_header/* default.src */.Z.src
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingInfo, {
                image: brake_rotor_colored,
                title: "Contact Us For A Quote.",
                buttonText: "Get A Free Brake Repair Estimate",
                orangeTitle: "Mobile Brake Service Starting At $119"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingScheduleService, {
                title: "Schedule your mobile brake repair in minutes."
            })
        ]
    });
};
/* harmony default export */ var pricing = (PricingPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2978,2932,9774,2888,179], function() { return __webpack_exec__(2691); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);